/* eslint-disable */
import React, { Component } from 'react'
import { Button, Icon } from 'semantic-ui-react';
import AgGridTable from '../agGrid/agGridTable'
import BranchModal from '../modalComponent/addBranch';
import UserActionButton from './userActionButton';
export default class BranchTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            update: false,
            search_value: '',
            loadingData: true,
            branches: [],
            open: false,
            editBranchInfo: [],
            regEditBranch: {},
            mode: '',
        }
    }

    componentDidUpdate(props) {
        // console.log(props, this.state.update)
        if (this.state.update) {
            this.setState({ update: false })
            // this.getData()
        }
    }

    FetchingBranchData = (data) => {
        let branchArr = [...this.state.branches]
        // console.log(data)
        let combine = { ...data, id: this.state.branches.length }
        branchArr.push(combine)
        this.setState({
            branches: branchArr,
            open: false
        }, () => this.props.gotBranchData(this.state.branches))
    }
    FetchingEditBranchData = (data) => {
        // console.log('Ed', data)
        this.setState({ mode: 'reg_edit', open: true })
        setTimeout(this.setState({ regEditBranch: data}), 500);
    }

    updated = (data) => {
        if (data) {
            this.setState({ update: !this.state.update })
        }
    }
    getEditUserDetials = (data) => {
        console.log(">>>", data)
        // let designation = data.designation.split(',')
        let newValues = [...this.state.branches]
        newValues[data.id] = {
            ...newValues[data.id],
            city_name: data.city_name,
            state_name: data.state_name,
            vendorBranchAccountNumber: data.vendorBranchAccountNumber,
            vendorBranchAddress: data.vendorBranchAddress,
            vendorBranchBankAccountHolder: data.vendorBranchBankAccountHolder,
            vendorBranchBankIFSC: data.vendorBranchBankIFSC,
            vendorBranchBankName: data.vendorBranchBankName,
            vendorBranchBranchPincode: data.vendorBranchBranchPincode,
            vendorBranchCancelledChq: data.vendorBranchCancelledChq,
            vendorBranchCity: data.vendorBranchCity,
            vendorBranchGST: data.vendorBranchGST,
            vendorBranchGSTCertPath: data.vendorBranchGSTCertPath,
            vendorBranchGSTExempPath: data.vendorBranchGSTExempPath,
            vendorBranchName: data.vendorBranchName,
            vendorBranchPAN: data.vendorBranchPAN,
            vendorBranchPANCardPath: data.vendorBranchPANCardPath,
            vendorBranchStateId: data.vendorBranchStateId,
        }
        this.setState({
            branches: newValues,
            open: false
        }, () => this.props.gotBranchData(this.state.branches))
    }
    handleBranchClose = () => {
        this.setState({
            open: false
        })
    }
    handleOpenBox = (data) => {
        this.setState({
            open: data,
            mode: 'allow_edit'
        })
    }
    handleBranchInfo = (data) => {
        this.setState({
            editBranchInfo: data
        })
    }
    render() {
        let columnDefs = [
            { headerName: 'Branch', field: 'vendorBranchName', enableRowGroup: true, enablePivot: true },
            { headerName: 'State', field: 'state_name', enableRowGroup: true, enablePivot: true },
            { headerName: 'PAN Number', field: 'vendorBranchPAN', enableRowGroup: true, enablePivot: true },
            { headerName: 'GST Number', field: 'vendorBranchGST', enableRowGroup: true, enablePivot: true },
            { headerName: 'Address', field: 'vendorBranchAddress', enableRowGroup: true, enablePivot: true },
            { headerName: 'City', field: 'city_name', enableRowGroup: true, enablePivot: true },
            { headerName: 'Pincode', field: 'vendorBranchBranchPincode', enableRowGroup: true, enablePivot: true },
            // { headerName: 'View Details', field: 'details', enableRowGroup: true, enablePivot: true },
            { headerName: 'Edit', field: 'edit', cellRenderer: 'actionRenderer', suppressToolPanel: true },
        ]
        console.log('>>BB', this.state.branches)
        return (
            <div>
                <AgGridTable
                    isLoading={this.state.loadingData}
                    columnDefs={columnDefs}
                    editable={true}
                    rowData={this.state.branches}
                    hiddenOEBtn={true}
                    hiddenNew={true}
                    getEditUserDetials={this.FetchingEditBranchData}
                    getBranchDetials={this.fetchBranchData}
                    pagination={true}
                    moreTitleComponents=
                    {<Button
                        type="button"
                        onClick={() => this.setState({ open: true, mode: '' })}
                        size="mini" color="blue" basic className="w3-text-white" icon><Icon name="plus" /> New</Button>}
                    exporthidden={true}
                    importhidden={true}
                    open={this.handleOpenBox}
                    branchInfo={this.handleBranchInfo}
                    searchbar={true}
                    loading={this.state.loading}
                    serverData={this.state.branches}
                    titleBarTitle={"Branch Details"}
                    actionButton={UserActionButton}
                    updated={this.updated}
                    baseURL={this.props.locationHistory}
                />
                <BranchModal
                    openBox={this.state.openBranchBox}
                    updated={this.props.updated}
                    handleClose={this.handleBranchClose}
                    getbranchdata={this.FetchingBranchData}
                    onClose={this.handleBranchClose}
                    getEditbranchdata={this.getEditUserDetials}
                    open={this.state.open}
                    mode={this.state.mode}
                    branchInfo={this.state.regEditBranch}
                />
            </div>
        )
    }
}
